
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class EnrollableStudentForm extends Form {
	private static _instance = new EnrollableStudentForm();

	public static getInstance(): EnrollableStudentForm {
		return EnrollableStudentForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.opsAllowed = {filter: true, get: true, create: true, update: true};
		this.keyFields = ["seasonId"];
	}

	public getName(): string {
		 return 'enrollableStudent';
	}
}


export class EnrollableStudentFd extends FormData {
	constructor(form: EnrollableStudentForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface EnrollableStudentVo extends Vo {
	departmentName?: string, 
	studentId?: number, 
	usn?: string, 
	degreeId?: number, 
	seasonId?: number, 
	programName?: string, 
	name?: string, 
	instituteId?: number, 
	isRegistered?: boolean
}
